import React from 'react'
import CloseIcon from '../Icons/CloseIcon'

const FocusPresetPopup = ({ selectedAudio, handleAudioChange, closePopup, audioFiles }) => {
    return (
        <div className='fixed top-0 left-0 right-0 z-20 flex items-center justify-center h-full overflow-x-hidden overflow-y-auto bg-zinc-800/90'>
            <div className="mx-auto flex max-w-[300px] flex-col rounded-lg border border-zinc-800 bg-zinc-900 p-4 text-sm text-zinc-400">
                <div className="flex justify-between gap-4 mb-2">
                    <span>Pomodoro duration (minutes)</span>
                    <span className='cursor-pointer hover:bg-zinc-800 hover:rounded-md hover:text-zinc-300' onClick={closePopup}>
                        <CloseIcon color='#3f3f3f' />
                    </span>
                </div>
                <p className="mb-2">Select An Audio</p>
                <select
                    className="w-full p-2 mb-3 font-normal text-left border-none rounded-md outline-none bg-zinc-800 placeholder-zinc-600"
                    onChange={handleAudioChange} value={selectedAudio || ""}>
                    <option value="">Select an Audio</option>
                    {audioFiles.map((audio, index) => (
                        <option key={index} value={audio.src}>
                            {audio.name}
                        </option>
                    ))}
                </select>
                <div>
                    <p className="mb-2">Duration</p>
                    <input
                        onChange={handleAudioChange}
                        name='longBreak'
                        placeholder="Minutes"
                        type="number"
                        className="w-full p-2 mb-5 font-normal text-left border-none rounded-md outline-none bg-zinc-800 placeholder-zinc-600"
                    />
                </div>
                <button
                    onClick={closePopup}
                    type="submit"
                    className="w-full py-2 text-sm text-center rounded-md outline-none bg-zinc-700 text-zinc-300 hover:bg-zinc-600 hover:text-zinc-200 focus:bg-zinc-600 focus:ring-0">
                    Save Preset
                </button>
            </div>
        </div>
    )
}

export default FocusPresetPopup